import { render, staticRenderFns } from "./DatePicker.vue?vue&type=template&id=2c604b56&scoped=true"
import script from "./DatePicker.vue?vue&type=script&lang=ts"
export * from "./DatePicker.vue?vue&type=script&lang=ts"
import style0 from "./DatePicker.vue?vue&type=style&index=0&id=2c604b56&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c604b56",
  null
  
)

export default component.exports